import { motion } from "framer-motion";

const Datenschutz = () => (
  <main className="pt-24 pb-20 bg-[#F8F5F0]" data-testid="datenschutz-page">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        <p className="uppercase tracking-[0.3em] text-xs text-[#8B5E3C] font-manrope mb-3">Rechtliches</p>
        <h1 className="font-playfair text-4xl text-[#2B2B2B] mb-10">Datenschutzerklärung</h1>

        <div className="space-y-8 font-manrope text-[#2B2B2B]/70 text-sm leading-relaxed">
          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">1. Datenschutz auf einen Blick</h2>
            <h3 className="font-semibold text-[#2B2B2B] mb-2">Allgemeine Hinweise</h3>
            <p>
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">2. Allgemeine Hinweise und Pflichtinformationen</h2>
            <h3 className="font-semibold text-[#2B2B2B] mb-2">Datenschutz</h3>
            <p>
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">3. Datenerfassung auf unserer Website</h2>
            <h3 className="font-semibold text-[#2B2B2B] mb-2">Kontaktformular</h3>
            <p>
              Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
            </p>
            <p className="mt-3">
              Rechtsgrundlage: Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen).
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">4. Ihre Rechte</h2>
            <p>
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen. Wenn Sie eine Einwilligung zur Datenverarbeitung erteilt haben, können Sie diese Einwilligung jederzeit für die Zukunft widerrufen.
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">5. Verantwortlicher</h2>
            <p>
              Marcus Loos<br />
              Schreinerei & Bestattungen Loos<br />
              Lorenkamp 4, 45721 Haltern am See<br />
              Telefon: 02364 / 5042567
            </p>
          </section>

          <section>
            <h2 className="font-playfair text-xl text-[#2B2B2B] mb-3">6. OpenStreetMap</h2>
            <p>
              Diese Seite nutzt über eine API den Kartendienst OpenStreetMap. Anbieter ist die OpenStreetMap Foundation, 132 Mayfair Court, 35 Great George Street, London, SW1P 3NY, UK. Wenn Sie eine Seite mit der OpenStreetMap-Karte aufrufen, wird unter anderem Ihre IP-Adresse an OpenStreetMap weitergeleitet. Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von OpenStreetMap: https://wiki.osmfoundation.org/wiki/Privacy_Policy.
            </p>
          </section>

          <div className="border-t border-[#8B5E3C]/15 pt-6 text-xs text-[#2B2B2B]/40">
            <em>Diese Datenschutzerklärung dient als Demo-Mustertext und muss vor dem Live-Betrieb durch einen Rechtsanwalt (Datenschutzrecht) geprüft und angepasst werden.</em>
          </div>
        </div>
      </motion.div>
    </div>
  </main>
);

export default Datenschutz;
